import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { Store } from '@ngxs/store';
import { isLocalhost } from '@trimble-gcs/common';
import { ScandataService } from '../scandata/scandata.service';
import { IngestionService, LocalhostIngestionService } from './ingestion.service';

export type IngestionServiceOptions = {
  mockWhenLocalhost: boolean;
};

const defaultIngestionServiceOptions: IngestionServiceOptions = {
  mockWhenLocalhost: true,
};

export function provideIngestionService(
  options = defaultIngestionServiceOptions,
): EnvironmentProviders {
  const localhostProviders: Provider[] = [
    {
      provide: IngestionService,
      useClass: LocalhostIngestionService,
    },
  ];

  const realProviders: Provider[] = [
    {
      provide: IngestionService,
      useClass: IngestionService,
      deps: [Store, ScandataService],
    },
  ];

  const { mockWhenLocalhost } = options;
  const providers = mockWhenLocalhost && isLocalhost() ? localhostProviders : realProviders;

  return makeEnvironmentProviders(providers);
}
